/********************************************************************************
 * Copyright (c) 2022 Cedalo GmbH
 *
 * All rights reserved. This program and the accompanying materials
 * are made available under the terms of the Eclipse Public License 2.0 which accompany this distribution.
 * and Eclipse Distribution License v1.0 which accompany this distribution.
 *
 * The Eclipse Public License is available at
 *   https://www.eclipse.org/legal/epl-2.0/
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
const { Reference } = require('@cedalo/parser');

const MSGBOX_REFERENCES = ['INBOX', 'INBOXMETADATA', 'INBOXDATA', 'OUTBOX', 'OUTBOXMETADATA', 'OUTBOXDATA'];
module.exports = class MessageBoxReference extends Reference {
	static isReference(str) {
		return MSGBOX_REFERENCES.includes(str);
	}
	static fromString(sheet, reference) {
		return MessageBoxReference.isReference(reference) ? new MessageBoxReference(sheet, reference) : undefined;
	}

	constructor(sheet, refstr) {
		super();
		this._sheet = sheet;
		this._refstr = refstr;
	}

	get value() {
		return this.getValue();
	}

	getValue() {
		return '#CALC';
	}

	copy() {
		return new MessageBoxReference(this._sheet, this._refstr);
	}

	isEqualTo(operand) {
		const equal = super.isEqualTo(operand);
		return equal && this._sheet === operand._sheet && this._refstr === operand._refstr;
	}

	isResolved() {
		return true;
	}

	toString(/* ...params */) {
		return this._refstr;
	}
};
